import { sha256 } from 'js-sha256';
import extractDomain from 'extract-domain';

jQuery( document ).ready( function() {
	
	if ( 'undefined' !== typeof gform ) {
		/**
		 * Track a first time input trigger.
		 */
		let hasFormChangeTriggered = false;
		let emailAddress = '';
		let formName = '';
		
		gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
			
			/**
			 * If its a email input, store the value of email in 'emailAddress' variable
			 * so it can be used later during form submission.
			 */
			if ( jQuery( elem ).parent().hasClass( 'ginput_container_email' ) ) {
				emailAddress = jQuery( elem ).val();
			}
			
			if ( ! hasFormChangeTriggered ) {
				const formEl = jQuery( `#gform_${ formId }` );
				formName = formEl.hasClass( 'join-the-newsletter' ) ? 'Join the Newsletter' : 'Contact Form';
				formName = formEl.hasClass( 'get-in-touch' ) ? 'Get In Touch' : formName;
				
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					event: 'custom.form.start',
					formID: formId,
					form: formName,
					action: 'start',
				} );
				
				// To manage the input interactivity once only.
				hasFormChangeTriggered = true;
			}
		}, 10 );
		
		/**
		 * Track when the form is submitted.
		 */
		jQuery( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
			
			const hashedEmailAddress = emailAddress ? sha256( emailAddress ) : '';
			
			/**
			 * Using a npm package to extract domain because sometimes the emails can
			 * have subdomain.
			 * @see https://stackoverflow.com/questions/49892932/how-to-get-domain-from-email-address-in-javascript
			 */
			const emailDomain = emailAddress ? extractDomain( emailAddress ) : '';
			
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				event: 'custom.form.complete',
				form: formName,
				formID: formId,
				action: 'complete',
				hashedEmail: hashedEmailAddress,
				domain: emailDomain,
			} );
		} );
	}
} );
